import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import LivestreamService from '@/services/LivestreamService';
export default {
  props: {
    limit: {
      type: Number,
      default: 0
    },
    channelId: {
      type: Number,
      default: 0
    },
    collapseable: {
      type: Boolean,
      default: false
    },
    liveOnly: {
      type: Boolean,
      default: false
    },
    hideChannelLink: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      loading: false,
      streams: [],
      collapsed: true
    };
  },
  mounted: function () {
    this.init();
  },
  methods: {
    init: function () {
      this.loading = true;
      const data = {
        scheduletype: 1
      };
      if (this.limit && this.limit > 0) {
        data.limit = this.limit;
      }
      if (this.channelId && this.channelId !== 0) {
        data.channel_id = this.channelId;
      }
      LivestreamService.getSchedule(data).then(response => {
        let results = response.data.results || [];
        if (this.liveOnly) {
          results = results.filter(stream => +stream.islive === 1);
        }
        this.streams = results;
        this.$emit('listCount', this.streams.length);
      }).catch(error => {
        this.$aim.error(error.response);
      }).finally(() => {
        this.loading = false;
      });
    }
  },
  watch: {
    channelId: function (n, o) {
      if (n !== o) {
        this.init();
      }
    }
  }
};